import React, { useEffect } from 'react';
import reframe from 'nike-re-framejs';
import i18n from '@i18n';
import CombinationNg from './CombinationNg';
import Accordion from '@/common/components/Accordion';
import './CombinationsNg.less';

function CombinationsNg({ ticket }) {
    return (
        <Accordion title={i18n('jsp.detailTiketu.kombinacie')} expanded={false}>
            <CombinationsList combinations={ticket.get('combinations')} hash={ticket.get('hash')} />
        </Accordion>
    );
}

function CombinationsList({ combinations, hash }) {
    useEffect(() => {
        if (!combinations) {
            reframe.dispatch(['ticketus/combinations/fetch', [hash]]);
        }
    }, [combinations, hash]);

    if (!combinations) {
        return <div className="linear-loader" />;
    }

    return (
        <div className="combinations-list">
            <div className="row">
                <div className="col head left">{i18n('jsp.detailTiketu.combination')}</div>
                <div className="col head">{i18n('jsp.tiket.vklad')}</div>
                <div className="col head">{i18n('jsp.detailTiketu.kurz')}</div>
                <div className="col head">{i18n('jsp.detailTiketu.eventualnaVyhra')}</div>
            </div>
            {combinations
                .map((comb, i) => (
                    <CombinationNg
                        key={i}
                        combination={i}
                        odds={comb.get('odds')}
                        stake={comb.get('stake')}
                        win={comb.get('win')}
                        status={comb.get('status')}
                    />
                ))
                .toList()}
        </div>
    );
}

export default CombinationsNg;
